import { useSelector } from 'react-redux';
import useSiteConfigSelector from 'components/useSiteConfigSelector';
import { hasClientAccessToFeature } from 'utils/clientSettings';

const useWrappedRecommendationsEnabled = () => {
  const [featuresSiteConfig] = useSiteConfigSelector(['Features']);
  const clientDetails = useSelector(state => state.main.clientDetails);

  if (!featuresSiteConfig || !clientDetails) {
    return false;
  }

  return hasClientAccessToFeature({
    featuresSiteConfig,
    featureName: 'wrappedRecommendations',
    clientDetails,
  });
};

export default useWrappedRecommendationsEnabled;
